import { z } from "zod";
import { JOB_LINKS } from "./job-links.constants";

export const JobShareUrlSchema = z
  .string()
  .max(JOB_LINKS.maxUrlLength)
  .url()
  .refine((value) => {
    let url: URL;
    try {
      url = new URL(value);
    } catch {
      return false;
    }
    return (
      JOB_LINKS.publicOrigins.some((origin) => url.origin === origin) &&
      !url.username &&
      !url.password &&
      JOB_LINKS.jobPath.test(url.pathname) &&
      !/\s/.test(value)
    );
  }, "Expected an artha.link creator job URL");

export const ShortJobUrlSchema = z
  .string()
  .url()
  .refine((value) => {
    let url: URL;
    try {
      url = new URL(value);
    } catch {
      return false;
    }
    return (
      JOB_LINKS.shortOrigins.some((origin) => url.origin === origin) &&
      !url.username &&
      !url.password &&
      url.pathname.length > 1 &&
      !url.search &&
      !url.hash
    );
  }, "Expected a me.artha.link or me.arthalink.info short URL");

export const ShortenJobLinksRequestSchema = z
  .object({
    urls: z.array(JobShareUrlSchema).min(1).max(JOB_LINKS.maxUrls),
  })
  .strict();

export const ShortenJobLinksResponseSchema = z.object({
  links: z
    .array(
      z.object({ originalUrl: JobShareUrlSchema, shortUrl: ShortJobUrlSchema }),
    )
    .min(1)
    .max(JOB_LINKS.maxUrls),
});
export type ShortenJobLinksRequestDto = z.infer<
  typeof ShortenJobLinksRequestSchema
>;
export type ShortenJobLinksResponseDto = z.infer<
  typeof ShortenJobLinksResponseSchema
>;
